(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  function initTileCountdowns() {
    var tiles = document.querySelectorAll('[data-product-tile-countdown][data-end]');
    if (!tiles.length) return;

    var now = Date.now();
    var countdowns = [];

    tiles.forEach(function (el) {
      var startMs = el.dataset.start ? new Date(el.dataset.start).getTime() : 0;
      var endMs   = new Date(el.dataset.end).getTime();
      var showSeconds = el.dataset.showSeconds === 'true';
      var timeEl = el.querySelector('.product-tile-countdown__time');

      if (!timeEl || isNaN(endMs)) return;

      if (now < startMs || now >= endMs) {
        el.classList.add('product-tile-countdown--hidden');
        return;
      }

      countdowns.push({ el: el, endMs: endMs, showSeconds: showSeconds, timeEl: timeEl, done: false });
    });

    if (!countdowns.length) return;

    var hasSeconds = countdowns.some(function (c) { return c.showSeconds; });

    function tick() {
      var n = Date.now();
      var anyActive = false;

      countdowns.forEach(function (c) {
        if (c.done) return;
        var diff = c.endMs - n;
        if (diff <= 0) {
          c.el.classList.add('product-tile-countdown--hidden');
          c.done = true;
          return;
        }
        anyActive = true;
        var totalSeconds = Math.floor(diff / 1000);
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (hours > 0) {
          c.timeEl.textContent = c.showSeconds
            ? pad(hours) + 'H : ' + pad(minutes) + 'M : ' + pad(seconds) + 'S'
            : pad(hours) + 'H : ' + pad(minutes) + 'M';
        } else {
          c.timeEl.textContent = c.showSeconds
            ? pad(minutes) + 'M : ' + pad(seconds) + 'S'
            : pad(minutes) + 'M';
        }
      });

      if (!anyActive) clearInterval(interval);
    }

    tick();
    var interval = setInterval(tick, hasSeconds ? 1000 : 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTileCountdowns);
  } else {
    initTileCountdowns();
  }
})();
